export default __webpack_public_path__ + "static/media/nlu-connecting.15056bb9.svg";